import { AuthenticationResult, EventMessage, EventType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { AppSettings } from '../Configuration/types';

let msalInstance: IPublicClientApplication | undefined;

const createLoginSuccessEventCallback = (msalInstance: IPublicClientApplication) => (event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    const account = (event.payload as AuthenticationResult).account;
    msalInstance.setActiveAccount(account);
  }
};

/**
 * Method used for instantiating the MSAL client used by the Application. Maintained outside of the component tree.
 */
export async function initializeMsalInstance(appSettings: AppSettings): Promise<void> {
  msalInstance = new PublicClientApplication({
    auth: {
      authority: appSettings.azure.authority,
      clientId: appSettings.azure.clientId,
      redirectUri: appSettings.azure.redirectUri
    },
    system: {
      allowRedirectInIframe: true
    }
  });

  let activeAccount = msalInstance.getActiveAccount();

  if (!activeAccount && msalInstance.getAllAccounts().length > 0) {
    activeAccount = msalInstance.getAllAccounts()[0];
    msalInstance.setActiveAccount(activeAccount);
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback(createLoginSuccessEventCallback(msalInstance));

  await msalInstance.initialize();
}

/**
 * Method to return the concrete MSAL Instance
 */
export function getMsalInstance(): IPublicClientApplication {
  if (!msalInstance) {
    throw new Error('MSAL Instance has not been instantiated.');
  }

  return msalInstance;
}
